<template>
	<div :style="viewStyles" class="">
		<customer-list v-model="selectedCustomerId" :customers="customers"/>

		<bottom-navigation @new-height="setBottomPadding">
			<template v-slot:left>
				<button class="btn btn-light btn-block" @click="$router.back()">{{ $t('Zurück') }}</button>
			</template>
			<template v-slot:right>
				<button class="btn btn-primary btn-block"
				        :disabled="!selectedCustomerId"
				        @click="finalizeCollection"
				>
					{{ $t('Fertig') }}
				</button>
			</template>
		</bottom-navigation>
	</div>

</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import allViews from "../../mixins/allViews";
import DataInput from "../../components/DataInput";
import BottomNavigation from "../../components/BottomNavigation";
import CustomerList from "../../components/CustomerList";

export default {
	name: "ChooseCustomer",
	components: {CustomerList, DataInput, BottomNavigation},
	mixins: [allViews],
	computed: {
		...mapGetters({
			getSelectedCustomer: "getSelectedCustomer",
			findLatestActionId: "getLatestActionId"
		}),
		...mapState({
			customers: state => state.Api.Customers.all,
			bottles: state => state.Api.Bottles.all,
			bottleCollection: state => state.bottleCollection,
			scid: state => state.selectedCustomerId,
		}),
		bottlesForCustomer() {
			return this.bottleCollection.map(serial => {
				return {
					serial: serial,
					customer_id: this.selectedCustomerId,
					parent_id: this.findLatestActionId(serial)
				}
			})
		},
		selectedCustomerId: {
			get() {
				return this.scid;
			},
			set(id) {
				this.setSelectedCustomerId(id)
			},
		}
	},
	created() {
		this.refreshCustomers()
			.catch(this.apiErrorHandler)
	},
	methods: {
		...mapActions({
			refreshCustomers: "Api/Customers/all",
			refreshBottles: "Api/Bottles/all",
			moveBottlesAtCustomer: "Api/Bottles/at_customer",
		}),
		...mapMutations({
			setSelectedCustomerId: "setSelectedCustomerId",
			setBottleCollection: "setBottleCollection"
		}),
		finalizeCollection() {
			if (this.bottlesForCustomer.find(el => !el.parent_id)) {
				//if there are bottles without a parent_id => refresh bottle list before
				this.refreshBottles()
					.then(this.moveBottles)
					.catch(error => {
						if (typeof error === "string") {
							this.cdvConfirm(this.$t("Internetverbindung benötigt"), this.$t("Um die ausgewählten Flaschen bewegen zu können muss die Flaschenliste aktualisiert werden.", this.finalizeCollection, this.$t('Erneut versuchen')),)
						} else {
							this.apiErrorHandler(error)
						}
					})
			} else {
				this.moveBottles()
			}
		},
		moveBottles() {
			let feedbackMsg1Bottle = this.$t('1 Flasche erfolgreich abgegeben');
			let feedbackMsgBottles = this.$t('Flaschen erfolgreich abgegeben');

			this.moveBottlesAtCustomer({
				bottles: this.bottlesForCustomer
			})
				.then(res => {
					if (res) {
						if (res.length === 1) {
							this.cdvAlert(feedbackMsg1Bottle);
						} else {
							this.cdvAlert([res.length, feedbackMsgBottles].join(' '));
						}
						this.setBottleCollection();
						this.$router.push('/home').catch(() => null);
					}
				})
				.catch(this.apiErrorHandler);

		}
	}
}
</script>

